<template>
  <div v-if="product.product">
    <div v-if="!show_delete && !removed">
      <div class="product-website-text d-flex align-center">
        <img
          :src="'https://8181.integ.crawlo.com/favicon?size=xs&website=' + product.website.url"
          @error="replaceByDefault"
          width="30"
          height="30"
          class="mr-2 favicon-img"
        />
        {{ product.website.alias }}
        <div class="ml-auto">
          <v-btn icon @click="show_edit_meta = !show_edit_meta">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
          <v-btn icon v-if="!default_product" @click="show_delete = true">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
      <v-text-field
        label="New product url"
        v-model="product.product.url"
        :background-color="background"
        :color="color"
        :rules="urlRule"
        solo
        hide-details
        clearable
        @input="valueChanged()"
      ></v-text-field>
    </div>
    <div class="ml-auto">
      <v-alert
        type="success"
        dense
        text
        class="mb-0 mt-4 mb-4 font-weight-bold"
        v-if="show_submit_edit_meta_success"
      >
        <v-row align="center">
          <v-col class="grow"> Product meta updated successfully. </v-col>
          <v-col class="shrink">
            <v-btn icon @click="show_submit_edit_meta_success = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-alert
        prominent
        type="error"
        dense
        text
        class="mb-0 mt-4 mb-4 font-weight-bold"
        v-if="show_submit_edit_meta_error"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ submit_edit_meta_error }}
          </v-col>
          <v-col class="shrink">
            <v-btn icon @click="show_submit_edit_meta_error = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <!-- <v-alert
        type="error"
        v-if="!show_submit_edit_meta_error"
        class="mb-0 mt-4 mb-4 font-weight-bold"
        dismissible
      >
        <div>
          {{ submit_edit_meta_error }}
        </div>
      </v-alert> -->
    </div>
    <div v-if="show_edit_meta" class="mt-2">
      <v-card outlined>
        <v-card-text>
          <v-row>
            <v-progress-linear
              v-if="submit_edit_meta_loading"
              indeterminate
              color="error"
            ></v-progress-linear>
          </v-row>
          <v-row>
            <v-col cols="12 pa-0">
              <span class="float-right">
                <v-btn icon @click="show_edit_meta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </span>
            </v-col>
            <v-col cols="3" class="pt-0">
              <v-text-field
                v-model="product.product.meta.coefficient"
                label="Price coefficient"
                type="number"
                min="0"
                step="0.01"
                outlined
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="pt-0">
              <!-- multi select list -->
              <div>
                <v-menu open-on-click offset-y bottom :close-on-content-click="false" v-if="false">
                  <template v-slot:activator="{ on: menu }" class="pa-4">
                    <v-btn text outlined color="primary" light v-on="{ ...menu }" clearable>
                      <v-icon left dark>$add</v-icon>
                      <span> Add more identifiers</span>
                      <span v-if="product.product.meta.identifiers.length">
                        | {{ product.product.meta.identifiers.length }}</span
                      >
                    </v-btn>
                  </template>
                  <v-card class="pa-0" flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-on:keyup.enter="
                              newIdentifier &&
                                !product.product.meta.identifiers.includes(newIdentifier) &&
                                product.product.meta.identifiers.push(newIdentifier) &&
                                (newIdentifier = '')
                            "
                            dense
                            v-model="newIdentifier"
                            small
                            outlined
                            hide-details
                            label="Add new identifier"
                            color="primary"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          newIdentifier && !product.product.meta.identifiers.includes(newIdentifier)
                        "
                        :class="{
                          'text-danger': product.product.meta.identifiers.includes(newIdentifier),
                        }"
                        style="cursor: pointer"
                        @click="
                          !product.product.meta.identifiers.includes(newIdentifier)
                            ? product.product.meta.identifiers.push(newIdentifier) &&
                              (newSecondaryEmail = '')
                            : null
                        "
                      >
                        <v-col cols="1">
                          <v-icon small>mdi-plus-circle-outline</v-icon>
                        </v-col>
                        <v-col cols="10">
                          {{ newIdentifier }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pa-0">
                          <v-list dense class="pa-2">
                            <v-list-item
                              class="pa-1"
                              v-for="(identifer, index) in product.product.meta.identifiers"
                              v-bind:key="identifer"
                            >
                              <v-list-item-content>
                                <v-row>
                                  <v-col cols="9" color="grey">{{ identifer }}</v-col>
                                  <v-col
                                    cols="2"
                                    @click="removeIdentifer(index, product)"
                                    style="cursor: pointer"
                                    ><v-icon small>mdi-close-circle-outline</v-icon></v-col
                                  >
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            @click="confirmMeta(product.product, product.website)"
            :loading="submit_loading"
          >
            Confirm
          </v-btn>
          <v-btn text @click="show_edit_meta = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div v-if="show_delete">
      <div class="product-website-text">
        <img
          :src="'https://8181.integ.crawlo.com/favicon?size=xs&website=' + product.website.url"
          @error="replaceByDefault"
          width="30"
          height="30"
          class="mr-2 favicon-img"
        />
        {{ product.website.alias }}
        <div v-if="removed">
          <div>
            <v-alert type="info" class="mb-0 mt-4 mb-4 font-weight-bold delete-text">
              <div>
                The deletion will applied when the edit is complete, you still can undo the deletion
              </div>
              <div>{{ product.product.url }}</div>
            </v-alert>
          </div>
          <div class="text-center mt-4">
            <v-btn color="primary" @click="undoDeletion(product.product)">Undo</v-btn>
          </div>
        </div>
        <div v-else>
          <div>
            <v-alert type="warning" class="mb-0 mt-4 mb-4 font-weight-bold delete-text">
              <div>
                Are you sure you want to delete "
                {{ product.website.alias }} " product ?
              </div>
              <div>{{ product.product.url }}</div>
            </v-alert>
          </div>
          <div class="text-center mt-4">
            <v-btn class="mr-2" color="primary" text @click="deleteProduct(product.product)"
              >Yes, delete it!</v-btn
            >
            <v-btn color="error" @click="show_delete = false">cancel</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  const isUrl = require('is-url')
  export default {
    name: 'editProductForm',
    props: ['product', 'default_product'],
    data() {
      return {
        removed: false,
        show_delete: false,
        show_edit_meta: false,
        submit_edit_meta_loading: false,
        show_submit_edit_meta_error: false,
        show_submit_edit_meta_success: false,
        submit_edit_meta_error:
          'An error occurred while editing the product meta, please try again.',
        submit_loading: false,
        background: '#ECFBE6',
        color: '#0BA058',
        newIdentifier: '',
        urlRule: [
          function (v) {
            return this.validatUrle(v)
          } || 'This url not valid, please try to correct it',
        ],
      }
    },
    methods: {
      removeIdentifer(index, product) {
        product.product.meta.identifiers.splice(index, 1)
      },
      deleteProduct() {
        this.removed = true
        this.$emit('delete-product', this.product)
      },
      undoDeletion() {
        this.removed = false
        this.show_delete = false
        this.$emit('undo-deletion-product', this.product)
      },
      confirmMeta(product, website) {
        this.submit_edit_meta_loading = true
        axios
          .post('/api/products/editProductMeta', {
            product: {
              ...product,
              website: website,
              account: localStorage.getItem('account_id'),
            },
          })
          .then((res) => {
            if (res.data.status !== 200) {
              this.submit_edit_meta_error = res.data.message
              this.show_submit_edit_meta_error = true
              return
            }

            this.show_submit_edit_meta_success = true
            setTimeout(() => {
              this.show_submit_edit_meta_success = false
            }, 3000)
          })
          .catch((error) => {
            this.show_submit_edit_meta_error = true
          })
          .finally(() => {
            this.submit_edit_meta_loading = false
            this.show_edit_meta = false
          })
      },
      validateUrl(url) {
        try {
          // Create a new URL object, which will throw an error if the URL is invalid
          let parsedUrl = URL.parse(url)

          console.log(parsedUrl)

          if (parsedUrl.host == null) return false

          if (parsedUrl.protocol == null) return false

          if (parsedUrl.hostname == null) return false

          //should have a domain suffix (e.g. .com, .org, .net, etc.)
          if (parsedUrl.hostname.split('.').length < 2) return false

          // URL constructor will handle spaces, but we should normalize and check if it's a valid URL
          return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
        } catch (error) {
          // If URL constructor throws an error, the URL is invalid
          return false
        }
      },
      valueChanged() {
        if (this.validateUrl(this.product.product.url)) {
          this.background = '#ECFBE6'
          this.color = '#0BA058'
        } else {
          this.background = '#FFE9ED'
          this.color = '#CC1E3F'
        }
      },
    },
  }
</script>
<style scoped>
  .product-website-text {
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
  .url_input {
    color: #ff0000;
    border-color: #ff0000;
  }
  .costum-bagde {
    text-transform: none;
    cursor: auto;
  }
  .product-name-text {
    font-size: 1.2rem;
  }
</style>
